import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button, useToast } from '../../../ds/components';
import { errorMessage } from '../../../lib/api';
import { requestFinancingAccess } from './api';
import styles from './financier.module.css';

/**
 * Finanzierer 09 „Kein Zugriff": shown by the record page on 403 `FINANCING_NOT_ASSIGNED` with `details.helper`.
 * „<helper> fragen" files an access request bound to this financing (`POST /approvals/access`, D-53).
 */
export function NotAssignedPage({ helper }: { helper: string | null }) {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { toast } = useToast();
  const [pending, setPending] = useState(false);
  const [sent, setSent] = useState(false);

  async function ask() {
    if (!id) return;
    setPending(true);
    try {
      await requestFinancingAccess(id);
      setSent(true);
      toast({ message: `Ihre Anfrage liegt bei ${helper ?? 'der Vertriebsleitung'}.` });
    } catch (error) {
      toast({ message: errorMessage(error) });
    } finally {
      setPending(false);
    }
  }

  return (
    <div className={styles.noAccess}>
      <div className={styles.noAccessInner}>
        <section className={styles.noAccessCard} aria-labelledby="financing-no-access-title">
          <div className={styles.eyebrow}>Kein Zugriff</div>
          <h1 id="financing-no-access-title" className={styles.noAccessTitle}>
            Diese Finanzierung ist Ihnen nicht zugewiesen.
          </h1>
          <div className={styles.noAccessText}>
            Finanzierer sehen nur Fälle, zu denen sie eine Task haben. Wenn Sie die Finanzierung übernehmen
            sollen, bittet der Vertriebskopf um die Zuweisung.
          </div>
          <div className={styles.noAccessActions}>
            <Button onClick={() => void navigate('/tasks')}>Zu meinen Tasks</Button>
            {helper && id ? (
              <Button variant="secondary" loading={pending} disabled={sent} onClick={() => void ask()}>
                {`${helper} fragen`}
              </Button>
            ) : null}
          </div>
        </section>
      </div>
    </div>
  );
}
